import { all, fork } from 'redux-saga/effects';
import globalSagas from './auth/sagas';

export default function* initSagas() {
  yield all([
    ...Object.values(globalSagas),
  ].map(fork));
}
